var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    stroke: "#12ABBF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.80952H5.5M8 7.80952C8 7.80952 10.0833 7.80952 10.0833 5.90476C10.0833 4.00001 8 4 8 4H6C5.72386 4 5.5 4.20467 5.5 4.45714V7.80952M8 7.80952C8 7.80952 10.5 7.80952 10.5 9.90476C10.5 12 8 12 8 12H6C5.72386 12 5.5 11.7954 5.5 11.5429V7.80952",
    stroke: "#12ABBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldSelect);
export default __webpack_public_path__ + "static/media/boldSelect.5ab26a063a9a53f0d9c642abf6e155ac.svg";
export { ForwardRef as ReactComponent };